<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">{{ title }}</h1>
              <div class="text-caption grey--text font-weight-medium">Solicita y gestiona tus certificaciones y trámites</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <div class="pa-8">
           <!-- Form Section -->
           <v-row>
             <v-col cols="12" md="5">
                <div class="glass-card-heavy rounded-xl pa-8 border shadow-soft-elite mb-6">
                   <h2 class="prism-heading text-h5 font-weight-black mb-6">Nueva Solicitud</h2>
                   
                   <v-alert
                    colored-border
                    border="left"
                    type="info"
                    class="rounded-xl elite-alert mb-8"
                    elevation="2"
                   >
                     <div class="font-weight-bold text-body-2">Los trámites marcados con asterisco (*) tienen costo administrativo.</div>
                   </v-alert>

                   <div class="mb-6">
                      <label class="text-overline font-weight-black grey--text mb-1 d-block">Tipo de Trámite</label>
                      <v-select
                        v-model="tramite"
                        :items="tramites"
                        item-text="text"
                        item-value="value"
                        label="Seleccionar Trámite"
                        outlined
                        class="elite-input rounded-xl"
                        hide-details
                      ></v-select>
                   </div>

                   <div class="mb-8">
                      <label class="text-overline font-weight-black grey--text mb-1 d-block">¿A quién va dirigido?</label>
                      <v-text-field
                        v-model="person"
                        :rules="personRules"
                        placeholder="Ej: Institución, Empresa o Particular"
                        outlined
                        class="elite-input rounded-xl"
                        hide-details
                        counter="20"
                      ></v-text-field>
                   </div>

                   <v-btn
                    color="primary"
                    x-large
                    block
                    class="rounded-xl font-weight-black shadow-glow"
                    @click="addTramite()"
                   >SOLICITAR TRÁMITE</v-btn>
                </div>
             </v-col>

             <!-- History Section -->
             <v-col cols="12" md="7">
                <div class="d-flex align-center mb-6">
                   <v-icon color="primary" class="mr-3">mdi-history</v-icon>
                   <h2 class="prism-heading text-h5 font-weight-black">Mis Trámites Recientes</h2>
                </div>

                <!-- Desktop Table -->
                <div class="glass-card-heavy rounded-xl overflow-hidden border shadow-soft-elite d-none d-md-block">
                   <v-simple-table class="elite-table">
                     <thead>
                       <tr>
                         <th class="text-overline font-weight-black">TRÁMITE</th>
                         <th class="text-overline font-weight-black text-center">ESTADO</th>
                         <th class="text-overline font-weight-black text-center">FECHA</th>
                         <th class="text-overline font-weight-black text-right">ACCIONES</th>
                       </tr>
                     </thead>
                     <tbody>
                       <tr v-for="(item, i) in tramitesUser" :key="i">
                         <td class="font-weight-bold grey--text text--darken-3">{{ item.tramite ? item.tramite.nombre : 'N/A' }}</td>
                         <td class="text-center">
                            <v-chip
                              small
                              :color="getStatusColor(item.Estado)"
                              class="font-weight-black"
                              text-color="white"
                            >
                              {{ item.Estado.toUpperCase() }}
                            </v-chip>
                         </td>
                         <td class="text-center grey--text text-caption font-weight-medium">{{ item.FechaRegistro }}</td>
                         <td class="text-right">
                            <v-btn
                              v-if="item.Estado == 'Cancelado' && item.motivo"
                              small
                              icon
                              color="error"
                              @click="motivoRechazoTramite(item.motivo)"
                              title="Ver motivo de rechazo"
                            >
                              <v-icon>mdi-alert-circle</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="item.url && hoy >= item.dias_expiracion"
                              icon
                              color="success"
                              :href="item.url"
                              target="_blank"
                              title="Descargar Constancia"
                            >
                              <v-icon>mdi-download-circle</v-icon>
                            </v-btn>
                         </td>
                       </tr>
                       <tr v-if="tramitesUser.length === 0">
                          <td colspan="4" class="text-center py-8 grey--text">Aún no has solicitado trámites.</td>
                       </tr>
                     </tbody>
                   </v-simple-table>
                </div>

                <!-- Mobile Cards -->
                <div class="d-md-none">
                   <div v-for="(item, i) in tramitesUser" :key="i" class="glass-card-interactive rounded-xl pa-5 mb-4 border shadow-soft">
                      <div class="d-flex justify-space-between align-start mb-3">
                         <div class="font-weight-black text-body-1 pr-2 line-height-1">{{ item.tramite ? item.tramite.nombre : 'N/A' }}</div>
                         <v-chip x-small :color="getStatusColor(item.Estado)" text-color="white" class="font-weight-black">
                            {{ item.Estado }}
                         </v-chip>
                      </div>
                      <div class="d-flex justify-space-between align-end">
                         <div class="grey--text text-caption">Solicitado: {{ item.FechaRegistro }}</div>
                         <div class="d-flex">
                            <v-btn
                              v-if="item.Estado == 'Cancelado' && item.motivo"
                              x-small
                              fab
                              depressed
                              color="error lighten-1"
                              class="mr-2"
                              @click="motivoRechazoTramite(item.motivo)"
                            >
                               <v-icon x-small color="white">mdi-alert-circle</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="item.url && hoy >= item.dias_expiracion"
                              x-small
                              fab
                              depressed
                              color="success"
                              :href="item.url"
                              target="_blank"
                            >
                               <v-icon x-small color="white">mdi-download</v-icon>
                            </v-btn>
                         </div>
                      </div>
                   </div>
                   <div v-if="tramitesUser.length === 0" class="text-center py-8 grey--text">Aún no has solicitado trámites.</div>
                </div>
             </v-col>
           </v-row>
        </div>
      </v-col>

      <!-- Modern Dialog for Rejection Reason -->
      <v-dialog v-model="motivoRechazo" max-width="450px" overlay-color="#0f172a" overlay-opacity="0.9">
        <v-card class="rounded-xl glass-card-heavy overflow-hidden">
          <v-card-title class="error white--text pa-6">
            <v-icon left color="white">mdi-alert-circle-outline</v-icon>
            <span class="prism-heading text-h6 font-weight-black">Motivo del Rechazo</span>
          </v-card-title>

          <v-card-text class="pa-8 pt-10 text-body-1 grey--text text--darken-3">
            {{ mensajeRechazo }}
          </v-card-text>

          <v-card-actions class="pa-8 pt-0">
            <v-btn color="primary" block x-large class="rounded-xl font-weight-black shadow-glow" @click="motivoRechazo = false">
              ENTENDIDO
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";

export default {
  name: "TramitesModerno",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    hoy: moment(new Date()).format("YYYY-MM-DD"),
    title: "Gestión de Trámites",
    tramite: { text: "", value: "" },
    sede: { text: "", value: "" },
    urgencia: { text: "Normal", value: "Normal" },
    tramites: [],
    tramitesUser: [],
    sedes: [],
    person: "",
    personRules: [(v) => !!v || "Campo obligatorio"],
    motivoRechazo: false,
    mensajeRechazo: "",
  }),

  methods: {
    getStatusColor(estado) {
      if (!estado) return 'grey';
      switch (estado.toLowerCase()) {
        case 'finalizado': return 'success';
        case 'cancelado': return 'error';
        case 'pendiente': return 'warning';
        case 'en proceso': return 'info';
        default: return 'grey';
      }
    },

    async addTramite() {
      if (!this.person || !this.tramite.value) {
        alert("Por favor complete todos los campos obligatorios.");
        return;
      }

      let dataSend = {
        process: this.tramite.value,
        sede: this.sede.value || 0,
        emergency: this.urgencia.value,
        person: this.person,
      };

      let url = "alumno-tramite/store";
      await this.$API
        .post({
          url: url,
          data: dataSend,
        })
        .then(() => {
          this.person = "";
          this.loadTramites();
          alert("Su solicitud ha sido enviada correctamente.");
        });
    },

    async loadTramites() {
      await this.$API
        .get({
          url: "alumno-tramites",
        })
        .then((res) => {
          this.tramitesUser = res || [];
        });
    },

    motivoRechazoTramite(motivo) {
      this.mensajeRechazo = motivo;
      this.motivoRechazo = true;
    },
  },

  mounted() {
    if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true) {
      this.$router.push({ name: "Home" });
    }

    this.$API
      .get({ url: "tramites", data: {} })
      .then((res) => { this.tramites = res || []; });

    this.$API
      .get({ url: "sedes", data: {} })
      .then((res) => { this.sedes = res || []; });

    this.loadTramites();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Alert Style */
.elite-alert {
  border-width: 0 0 0 6px !important;
}

/* Glass Cards */
.glass-card-heavy {
  background: white;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
}

.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(26, 35, 126, 0.1) !important;
  border-color: #1a237e !important;
}

.shadow-soft-elite {
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03) !important;
}

/* Elite Inputs */
.elite-input ::v-deep fieldset {
  border-color: rgba(0,0,0,0.08) !important;
  border-radius: 16px !important;
}

/* Table Style */
.elite-table {
  background: transparent !important;
}
.elite-table thead th {
  background-color: #f8fafc !important;
  color: #64748b !important;
  height: 50px !important;
}
.elite-table tbody tr {
  transition: background-color 0.2s ease;
}
.elite-table tbody tr:hover {
  background-color: rgba(26, 35, 126, 0.02) !important;
}

.shadow-glow {
  box-shadow: 0 10px 20px -5px rgba(26, 35, 126, 0.3) !important;
}

.line-height-1 { line-height: 1.25; }

/* Responsive adjustments */
@media (max-width: 960px) {
  .prism-top-bar { padding: 1.5rem !important; }
}
</style>
